import { render, staticRenderFns } from "./NewProposalGroup.vue?vue&type=template&id=14ebd450"
import script from "./newProposalGroup.ts?vue&type=script&lang=ts&external"
export * from "./newProposalGroup.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports